import type { IClientMicrocreditListItem } from '@src/@types/clienttypes';
import { getCurrency } from '@src/helpers/currency';

import { BASE_URL } from '../../config';

import { getAddress } from './getAdress';

export const mapMicrocreditToSchema = (path: string, product: IClientMicrocreditListItem, index: number) => {
  const { rates, details } = product;

  const rangeData = {
    amount: { minValue: Infinity, maxValue: -Infinity },
    rate: { minValue: Infinity, maxValue: -Infinity },
    term: { minValue: Infinity, maxValue: -Infinity },
  };
  rates.forEach((rate) => {
    rangeData.amount.minValue = Math.min(rate.amount.from, rangeData.amount.minValue);
    rangeData.amount.maxValue = Math.max(rate.amount.to, rangeData.amount.maxValue);
    rangeData.rate.minValue = Math.min(rate.rate.from, rangeData.rate.minValue);
    rangeData.rate.maxValue = Math.max(rate.rate.to, rangeData.rate.maxValue);
    rangeData.term.minValue = Math.min(rate.term.fromValue / 60 / 24, rangeData.term.minValue);
    rangeData.term.maxValue = Math.max(rate.term.toValue / 60 / 24, rangeData.term.maxValue);
  });

  const mfoUrl = `${BASE_URL}/zaimy/mfo/${product.organization.alias}/`;

  return {
    '@type': 'ListItem',
    position: index + 1,
    item: {
      '@type': 'LoanOrCredit',
      '@id': `${mfoUrl}#offer`,
      name: `Займ онлайн ${product.organization.name}`,
      url: mfoUrl,
      amount: {
        '@type': 'MonetaryAmount',
        currency: getCurrency(path),
        ...rangeData.amount,
      },
      loanTerm: {
        '@type': 'QuantitativeValue',
        name: 'Срок займа',
        ...rangeData.term,
        unitCode: 'DAY',
      },
      annualPercentageRate: {
        '@type': 'QuantitativeValue',
        name: 'Годовая ставка',
        minValue: details?.psk?.from ?? 0,
        maxValue: details?.psk?.to ?? 0,
        unitText: '%',
      },
      interestRate: {
        '@type': 'QuantitativeValue',
        name: 'Ставка в день',
        ...rangeData.rate,
        unitText: '%/день',
      },
      lendingOrganization: {
        '@type': 'FinancialService',
        '@id': `${mfoUrl}#org`,
        name: product.organization.name,
        url: mfoUrl,
        logo: {
          '@type': 'ImageObject',
          url: product.organization.logotypes.android || product.organization.logo,
        },
        telephone: product.organization.contacts?.phone?.at(-1) ?? '',
        address: {
          '@type': 'PostalAddress',
          ...getAddress(product.organization.contacts.address, 'ru'),
        },
        areaServed: 'RU',
      },
      potentialAction: {
        '@type': 'ApplyAction',
        name: 'Оформить займ',
        target: product.advertising.monetization.pixels.click,
      },
    },
  };
};
